import { render, staticRenderFns } from "./ModulesCollege.vue?vue&type=template&id=222f8c3a&scoped=true&"
import script from "./ModulesCollege.vue?vue&type=script&lang=js&"
export * from "./ModulesCollege.vue?vue&type=script&lang=js&"
import style0 from "./ModulesCollege.vue?vue&type=style&index=0&id=222f8c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f8c3a",
  null
  
)

export default component.exports